import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-loader-icon',
  templateUrl: './shopping-loader.component.html'
})
export class ShoppingLoaderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
